// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"style_btn-wrapper__aFX65","circleButtons":"style_circleButtons__KeW9T","status":"style_status__BENOz"};